import Carousel from './carousel.vue'
export default Carousel